import React from "react";
import { Modal } from "react-bootstrap";
import AddIcon from "../assets/img/create-add.svg";
import SaveIcon from "../assets/img/save-icon.svg";

const SaveTemplate = ({ show, onHide, onCreateNewBoard, onUseSavedTemplate }) => {
  return (
    <div>
      <Modal
        show={show}
        onHide={onHide}
        dialogClassName=""
        centered
        className="deletModal create-board-modal"
      >
          <Modal.Header closeButton={true}>
           <div className="modal-title">Create</div>
        </Modal.Header>
        <Modal.Body>
          <div className="create-templete-cover cursor_pointer" onClick={onCreateNewBoard}>
              <div className="create-templete-box">
              <img src={AddIcon} alt="AddIcon" className="add-icon" />
              <p>Create Board</p>
           </div>
           </div>
         <div className="create-templete-cover cursor_pointer" onClick={onUseSavedTemplate}>  
            <div className="create-templete-box">
              <img src={SaveIcon} alt="SaveIcon" className="save-icon" />
              <p>Create Board with Template</p>
           </div>
          </div>
          

        </Modal.Body>
       
      </Modal>
    </div>
  );
};

export default SaveTemplate;
